import { render, staticRenderFns } from "./SdfPopup.vue?vue&type=template&id=581b195c&scoped=true"
import script from "./SdfPopup.vue?vue&type=script&lang=js"
export * from "./SdfPopup.vue?vue&type=script&lang=js"
import style0 from "./SdfPopup.vue?vue&type=style&index=0&id=581b195c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b195c",
  null
  
)

export default component.exports